export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/tuner-icon.svg?38ebbe6eeb2d21b95c1e636954f2e1c9";